"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const track = (sdk) => {
    const { sdkConfig: { url } } = sdk;
    const httpClient = sdk.httpClient;
    return {
        trackEvent: async (isPublic, payload) => {
            const result = await httpClient.post(`${url}/v4/track`, {
                payload,
                query: { isPublic },
                auth: !isPublic
            });
            return result.data;
        },
    };
};
exports.default = track;
